import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { getProdBaseRequestUrl } from "@/utils/constants";
import { message } from 'antd';
import { convertRes2Blob, convertRes2Blob2WithFileName } from "@/utils/exportFile";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { InvoiceBillSearch, InvoiceBill, InvoiceSummary } from "@/views/invoice/manage/InvoiceManageTypes";

export const recordModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs, setLoadingInfo } = useGlobalModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<InvoiceBillSearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<InvoiceBill[]>([]);
    const [summaryData, setSummaryData] = useState<InvoiceSummary>();
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<InvoiceBill[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
    }

    const onReset = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        setSelectedData([])
        loadData(initPgCfg, {});
    }

    const updateSearchParam = (updateParam: InvoiceBillSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: InvoiceBillSearch = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }

        let { retData } = await invoiceManageService.invoiceBillPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        let { retData: summaryData } = await invoiceManageService.invoiceBillSummary(searchParams);
        setSummaryData(summaryData);
    }

    //单据发票导出
    const invoiceBillExport = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '导出中,请稍等...' });
        const searchParams = {
            ...searchParam,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER
        }
        let result = await invoiceManageService.invoiceBillExport(searchParams);
        convertRes2Blob(result);
        setLoadingInfo({ loadingVisible: false, txt: '' });
    }

    //单据发票导出附件
    const invoiceBillExportAttach = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '导出中,请稍等...' });
        const searchParams = {
            ...searchParam,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER
        }
        let ret = await invoiceManageService.invoiceMd5(searchParams);
        let md5List = Array.from(Object.values(ret), x => x);
        if (md5List.length > 0) {
            console.log(md5List)
            let fileServerUrl = getProdBaseRequestUrl() + "/fsrv/download_zip";

            let fileName = "单据发票附件.zip";
            let file = await invoiceManageService.invoiceMd5Export(fileServerUrl, { "zipName": fileName, "files": md5List });
            convertRes2Blob2WithFileName(file, fileName);
        }
        else {
            message.error("没有附件信息")
        }
        setLoadingInfo({ loadingVisible: false, txt: '' });
    }

    return {
        /***field***/
        initPgCfg,
        searchParam,
        dataSource,
        pgCfg,
        summaryData,
        beDs,
        selectedRowKeys,
        selectedData,
        /***method***/
        setDataSource,
        updateSearchParam,
        loadData,
        onSearch,
        onReset,
        invoiceBillExport,
        invoiceBillExportAttach,
        setSelectedRowKeys,
        setSelectedData,
    }
});
